export default "__VITE_ASSET__DppkmJr6__"